export default {
  receivablesManageList: {
    search: {
      registerStartDate: '收款日期从',
      registerEndDate: '收款日期到',
      anotherPayStartTime: '代付时间从',
      anotherPayEndTime: '代付时间到',
    },
    // 收款登记
    registerColumn: {
      registerNo: '收款登记号',
      registerCompanyCode: '公司',
      registerDate: '收款日期',
      registerCreatePersonName: '制单人',
      receiveMethod: '收款方式',
      receiveResource: '来源',
      receiveBankName: '收款银行',
      receiveBankAccount: '收款银行账号',
      receiveStatus: '收款状态',
      payerName: '付款单位',
      payBankName: '付款银行',
      payBankAccount: '付款银行账号',
      bankFlowNo: '银行流水号',
      receiveInfoCurrencyCode: '币种',
      originReceiveMoneyAmount: '收款金额',
      originProformaInvoiceAmount: '形式发票金额',
      originDomesticBankDeductFee: '国内银行扣费',
      originForeignBankDeductFee: '国外银行扣费',
      summary: '摘要',
    },
    // 收款认领
    claimColumn: {
      seq: '序号',
      registerNo: '收款登记号',
      registerCompanyCode: '公司代码',
      payerName: '付款单位',
      payBankName: '付款银行',
      payBankAccount: '付款银行账号',
      bankFlowNo: '银行流水号',
      receiveBankName: '收款银行',
      receiveBankAccount: '收款银行账号',
      registerDate: '收款日期',
      registerCreatePersonName: '制单人',
      voucherCreateDate: '收款单制单日期',
      receiveMethod: '收款方式',
      receiveResource: '来源',
      receiveInfoCurrencyCode: '币别',
      originProformaInvoiceAmount: '形式发票金额',
      originReceiveMoneyAmount: '收款金额',
      originDomesticBankDeductFee: '国内银行扣费',
      originForeignBankDeductFee: '国外银行扣费',
      claimDepartmentNo: '认领部门',
      customerName: '认领客户',
      receiveStatus: '收款状态',
      customerNo: '客户',
      preclaimDepartmentCode: '预认领部门',
      existVoucher: '是否创建收款单',
      isAnotherPay: '是否代付',
      anotherPayTime: '代付时间',
      financeAuditStatus: '财务审核状态',
      firstClaimAmount: '一次认领总金额',
      secondClaimAmount: '二次认领总金额',
      firstUnClaimAmount: '未一次认领金额',
      secondUnClaimAmount: '未二次认领金额',
      summary: '摘要',
    },
    // 收款单
    orderColumn: {
      docNo: '收款单号',
      registerDate: '收款日期',
      voucherCreateDate: '创建日期',
      createPersonName: '制单人',
      receiveMethod: '收款方式',
      receiveResource: '来源',
      receiveBankName: '收款银行',
      receiveBankAccount: '收款银行账号',
      receiveStatus: '收款状态',
      payerName: '付款单位',
      payBankName: '付款银行',
      payBankAccount: '付款银行账号',
      bankFlowNo: '银行流水号',
      receiveInfoCurrencyCode: '币种',
      originReceiveMoneyAmount: '收款金额',
      originProformaInvoiceAmount: '形式发票金额',
      originDomesticBankDeductFee: '国内银行扣费',
      originForeignBankDeductFee: '国外银行扣费',
      summary: '摘要',
      isAnotherPay: '是否代付',
      anotherPayTime: '代付时间',
      financeAuditStatus: '财务审核状态',
      accountingStatus: '收款单入账状态',
      anotherPayAccountStatus: '代付入账状态',
      registerNo: '收款登记号',
    },
    placeholder: {
      auto: '自动生成',
      receivedTypePlaceholder: '请选择收款类别',
      claimDepartmentNoPlaceholder: '请选择部门',
      originReceiveMoneyAmountPlaceholder: '请选择收款金额',
    },
    button: {
      save: '保存',
      firstSave: '保存一次认领',
      secondSave: '保存二次认领',
      submit: '提交',
      cancel: '取消',
      determine: '确定',
      createFinancialVoucher: '收款单过账',
      reverseVoucher: '收款单冲销',
      upload: '附件上传',
      createReceipt: '生成收款单',
      submitFinanceAudit: '提交财务审核',
      passFinanceAudit: '财务审核通过',
      rejectFinanceAudit: '财务审批驳回',
      pushGoldie: '推送金蝶',
    },
    message: {
      submit: '提交数据？',
      noEdit: '只能对已登记和待认领的数据进行操作！',
      noEditByReceipt: '该条记录不能修改，只能对手工创建未生成财务凭证之前的收款单进行操作！',
      noRegister: '只能对已登记的数据进行操作！',
      noClaimed: '只能对已认领（如果是代付必须审核通过）的数据进行操作！',
      noOrder: '只能对已生成收款单的数据进行操作！',
      noPosting: '只能对已过账的数据进行操作！',
      onlyOneSelectData: '请选择一条数据进行操作',
      noSelectData: '请至少选择一条数据进行操作',
      noSelected: '您还未选择任何数据!',
      noCanSelectRegisterData: '所选数据中没有已登记状态，请重新选择！',
      hasCannotDelRegisterTip:
        '所选数据中有不可删除的数据，点击确认只会删除已登记或待认领状态的数据！',
      hasCannotSubmitRegisterTip: '所选数据中有不可提交的数据，点击确认只会提交已登记状态的数据！',
      noCanDelSelectOrderData: '所选数据中没有财务过账前状态，请重新选择！',
      hasCannotDelOrderTip: '所选数据中有不可删除的数据，点击确认只会删除财务过账前的数据！',
      cancel: '撤销数据？',
      noCanClaimSelectData: '所选数据中没有可认领状态，请重新选择！',
      noCanRegisterSelectData: '所选数据中没有已登记或待认领状态，请重新选择！',
      hasCannotBatchOneClaim:
        '所选数据中有不可批量一次认领数据，点击确认只会批量认领已登记状态的数据！',
      ledgerInfo: '请先配置公司账套',
      rateInfo: '缺少对应汇率，请维护',
      calcInfo: '已认领金额不能超过总金额，请重新输入金额！',
      createOrder: '是否对选中数据生成收款单？',
      writeOff: '是否对选中数据进行冲销？',
      noWriteOff: '当前选中数据不可重复冲销！',
      isPosting: '是否对选中数据进行过账？',
      noAccount: '当前选中数据不可重复过账！',
    },
  },
};
